import { render, staticRenderFns } from "./ServicesSelector.vue?vue&type=template&id=325d451b&scoped=true&"
import script from "./ServicesSelector.vue?vue&type=script&lang=ts&"
export * from "./ServicesSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesSelector.vue?vue&type=style&index=0&id=325d451b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d451b",
  null
  
)

export default component.exports